import React, { useCallback, useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { LatexRenderer } from '../../components/ui/LatexRenderer';
import { shuffleOptions } from '../../utils/deterministicShuffle';
interface AssessmentMCOptionsProps {
  questionId: string;
  options: string[];
  onSelect: (originalIndex: number) => void;
  selectedOriginalIndex: number | null;
}
const LABELS = ['A', 'B', 'C', 'D'];
export function AssessmentMCOptions({
  questionId,
  options,
  onSelect,
  selectedOriginalIndex
}: AssessmentMCOptionsProps) {
  const [shuffledOptions, setShuffledOptions] = useState<Array<{
    text: string;
    originalIndex: number;
  }>>([]);
  useEffect(() => {
    setShuffledOptions(shuffleOptions(options, questionId));
  }, [questionId, options]);
  const handleSelect = useCallback((index: number) => {
    if (shuffledOptions[index]) {
      onSelect(shuffledOptions[index].originalIndex);
    }
  }, [shuffledOptions, onSelect]);
  // Keyboard shortcuts (A, B, C, D or 1, 2, 3, 4)
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      const key = e.key.toUpperCase();
      let index = -1;
      if (['A', 'B', 'C', 'D'].includes(key)) {
        index = key.charCodeAt(0) - 65;
      } else if (['1', '2', '3', '4'].includes(key)) {
        index = parseInt(key) - 1;
      }
      if (index >= 0 && index < shuffledOptions.length) {
        handleSelect(index);
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [shuffledOptions, handleSelect]);
  return <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 w-full max-w-3xl mx-auto" data-id="element-697" data-mp="35oebeenp1nh">
      {shuffledOptions.map((option, index) => {
      const isSelected = option.originalIndex === selectedOriginalIndex;
      return <motion.button key={`${questionId}-${index}`} onClick={() => handleSelect(index)} whileHover={{
        scale: 1.01
      }} whileTap={{
        scale: 0.98
      }} className={`
              relative flex items-center p-4 sm:p-5 rounded-2xl text-left transition-all duration-200 shadow-sm
              ${isSelected ? 'bg-indigo-50 ring-2 ring-indigo-600 shadow-md' : 'bg-white hover:shadow-md'}
            `} data-id="element-698" data-mp="1xgbbyuda3lhp" data-mpi={index}>
            {/* CITO-style Label */}
            <div className={`
                flex-shrink-0 w-9 h-9 sm:w-10 sm:h-10 rounded-full flex items-center justify-center font-bold text-sm sm:text-base mr-4 transition-colors
                ${isSelected ? 'bg-indigo-600 text-white' : 'bg-slate-100 text-slate-500'}
              `} data-id="element-699" data-mp="2jprtoai2vmtq">
              {LABELS[index]}
            </div>

            {/* Option Text */}
            <div className={`flex-1 text-fluid-base sm:text-fluid-lg font-medium ${isSelected ? 'text-indigo-950' : 'text-slate-700'}`} data-id="element-700" data-mp="32i2pxli88miv">
              <LatexRenderer content={option.text} data-id="element-701" data-mp="351z1jyybptqk" />
            </div>
          </motion.button>;
    })}
    </div>;
}